import { createSelector } from 'reselect';
import RfidOnRouteNonConsolidatedReportColumns from '../../containers/RfidOnRouteNonConsolidatedReportColumns';
import TableDefinitions from '../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPORTING_RFID_ON_ROUTE_NON_CONSOLIDATED.isLoading;
export const getData = TableDefinitions.REPORTING_RFID_ON_ROUTE_NON_CONSOLIDATED.getDataFunction();
export const getColumns = createSelector(getData, RfidOnRouteNonConsolidatedReportColumns);
